import { makeStyles } from '@material-ui/core';

const makeClasses = makeStyles(() => ({
	root: {
		height: '100vh'
	}
}));

export default makeClasses;
